import type { ReactNode } from 'react';
import './store';

type LegendStateProviderProps = {
  children: ReactNode;
};

export const LegendStateProvider = ({ children }: LegendStateProviderProps) => (
  <>{children}</>
);
